var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec4Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_4_9",
    "data-name": "Component 4 \\u2013 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.372,
    height: 63.25,
    viewBox: "0 0 156.372 63.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M869.975,1244.491s2.74-13.663,10.914-22.918l-3.468.233-1.3-1.243.1,1.417-5.249,1.618s2.085-8.185,10.35-4.982a16.182,16.182,0,0,0-11.21-4.083l3.721-1.726.016.835a4.563,4.563,0,0,1,4.853-.526l-.359,1.087,1.214-.609a5.917,5.917,0,0,1,3.255,2.913,3.869,3.869,0,0,0-.326-2.851l1.265-.728-1.73-.247a6.334,6.334,0,0,0-3.611-4.121s8.971,1.588,7.446,8.312c0,0,4.566-3.225,8.622,2.687l-2.124-.518-.308-1.086-.414.891s-2.353-.964-3.963.415l2.225,1.1-.229,1.439,1.259-.709s3.536,2.789,2.019,8.825c0,0-3.048-6.4-6.982-8.924,0,0,3.854,5.6-2.488,10.484l.08-3.069s3.492.345-.129-.923c0,0,1.021-2.367-1.292-5.5a59.733,59.733,0,0,0-9.974,23.114Z",
    transform: "translate(-865.242 -1205.05)",
    fill: "#e4a231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M877,1205.429c-.962,1.638-1.347,8.378-1.347,14.93v27.592h3.207c5.966,0,12.573-1.26,13.855-2.9v4.472H865.9c.9-1.574,1.348-7.559,1.348-13.67v-15.5c0-6.426-.45-13.292-1.412-14.93Z",
    transform: "translate(-865.404 -1205.115)",
    fill: "#1e2631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M920.058,1235.55c0,6.111.513,12.1,1.347,13.671h-9.751v-4.914a8.877,8.877,0,0,1-7.953,5.228c-5.709,0-9.044-4.724-9.044-10.016,0-7.433-.257-17.072-1.347-19.025H903V1235.8c0,6.993,1.347,10.4,4.169,10.4,2.5,0,4.49-4.1,4.49-9.323v-1.449c0-6.552-.385-13.293-1.347-14.93l9.75-.063Z",
    transform: "translate(-864.333 -1204.809)",
    fill: "#1e2631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M948.839,1220.493l-9.686,12.221c2.182,4.347,7.057,13.607,10.007,16.5H938.447l-5.58-10.078h-.128c-2.437,3.4-4.426,7.37-4.426,9.322a2.337,2.337,0,0,0,.128.756h-6.67l10.134-11.969c-2.052-3.653-7.5-14.174-10.134-16.757h10.712l5.58,10.268h.129c2.309-3.464,4.105-7.5,4.105-9.449a1.558,1.558,0,0,0-.192-.819Z",
    transform: "translate(-863.224 -1204.807)",
    fill: "#1e2631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M950.9,1219.1c0-6.11-.449-12.094-1.348-13.67H959.3V1234.6c0,6.551.449,13.292,1.346,14.929H950.9Z",
    transform: "translate(-862.142 -1205.115)",
    fill: "#e4a231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M964.418,1234.163c0-6.11-.449-12.1-1.347-13.67h9.751v13.8c0,2.835.063,12.662,1.346,14.93l-9.75.063Z",
    transform: "translate(-861.615 -1204.807)",
    fill: "#e4a231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M991.977,1213.5a7.772,7.772,0,0,0,.128-1.322c0-2.646-1.154-5.355-4.169-5.417h-.128c-2.631,0-3.4,1.26-3.4,3.15a23.972,23.972,0,0,0,1.025,5.417,21.131,21.131,0,0,1,1.091,5.481h5.2v1.576h-5.2v12.22c0,6.552.384,13.293,1.348,14.93h-9.751v-27.15h-2.951v-1.576h2.951v-5.04c0-7.748,5-10.646,10.392-10.646,3.014,0,5.965.882,7.953,3.842Z",
    transform: "translate(-861.143 -1205.121)",
    fill: "#e4a231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1005.172,1249.54c-8.659,0-13.085-7.055-13.085-14.3,0-7.5,4.681-15.057,13.726-15.057,6.222,0,9.686,3.591,9.686,7.5,0,3.969-3.529,8.253-14.433,8.316.641,5.228,3.143,10.33,7.761,10.33a8.067,8.067,0,0,0,7.056-4.346c-1.411,4.6-5.067,7.559-10.712,7.559m4.875-22.679c0-2.331-1.09-5.1-3.464-5.1-5,0-5.645,9.071-5.645,12.662,6.479,0,9.109-3.9,9.109-7.56",
    transform: "translate(-860.484 -1204.814)",
    fill: "#e4a231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1016.306,1267.408H870.9a5.452,5.452,0,0,1-5.485-5.386v-4.273a5.453,5.453,0,0,1,5.485-5.387h145.4a5.453,5.453,0,0,1,5.485,5.387v4.273a5.452,5.452,0,0,1-5.485,5.386",
    transform: "translate(-865.42 -1204.158)",
    fill: "#1e2631"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Miami_Real_Estate_LLC",
    "data-name": "Miami Real Estate LLC",
    transform: "translate(10.186 59.727)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Miami Real Estate LLC")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(100.145 5.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M974.053,1212.252l-1.92,5.476a14.61,14.61,0,0,0-8.4.005l-1.923-5.481,2.055,1.419-.441,1.191.036.029a1.435,1.435,0,0,0,2.131-.375l-.971-.92,1.066-2.682,1.8,2.06-.791,1.37.221.223a1.437,1.437,0,0,0,2.034,0l.221-.223-.792-1.37,1.8-2.06,1.066,2.682-.971.92a1.435,1.435,0,0,0,2.131.375l.036-.029-.44-1.191Z",
    transform: "translate(-961.809 -1210.914)",
    fill: "#e4a231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M971.951,1217.883l-.2.545a14.891,14.891,0,0,0-7.815.013l-.183-.549a14.7,14.7,0,0,1,8.2-.009",
    transform: "translate(-961.733 -1210.784)",
    fill: "#e4a231"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec4Logo);
export default __webpack_public_path__ + "static/media/sec4_logo.8b870dafbb9505174ad7bc3f6128e3a9.svg";
export { ForwardRef as ReactComponent };